import { registerResultRenderer } from '../model/result-renderer-registry';
import { ApplyFiltersConfirmation } from './apply-filters-confirmation';

// Side-effect: register the 'apply_filters' renderer at module load. This
// lives in the agent-panel feature itself (not in any consumer page's
// adapter) because the chip is page-agnostic — every page that emits
// `kind: 'apply_filters'` (products, operations, future ones) wants the
// same in-panel confirmation visible during the auto-close window.
//
// The barrel below imports this for its side effect, so any app that
// pulls in `@agent-panel/index` gets the renderer registered.
registerResultRenderer('apply_filters', ApplyFiltersConfirmation);
